import { AppConnection } from 'views/client/connections';
import { Activity } from 'views/client/logs/index';
import { Dashboard } from 'views/client/dashboard/index';
import { HealthScore } from 'views/client/dashboard/healthScore';
import { Help } from 'views/account/help';
import { OnboardingView } from 'views/onboarding/onboarding';
import { Restore } from 'views/client/tools/restore/restore';
import { RestoreDetails } from 'views/client/tools/restore/restoreDetails';
import { RestoreHistory } from 'views/client/tools/restore/restoreHistory';
import { Details } from 'views/client/logs/details';
import { Details as MonitorsDetails } from 'views/client/monitors/details';
import { Monitors } from 'views/client/logs/cleanup';
import { Rules } from 'views/client/monitors/rules';
import { RuleDetails } from 'views/client/monitors/ruleDetails';
import { Chat, Agents, Analysis } from 'views/client/ai';
import {Error } from 'views/error/qboConnectionError';
import { KanbanBoard } from 'views/client/work/cleanup/kanbanBoard';
import { ReportDashboard } from 'views/client/tools/metrics';
import { Export } from 'views/client/tools/export';
import { Account } from 'views/account';
import { APIKeyList } from 'views/account/apikey/list';
import { APIKeyEditor } from 'views/account/apikey/edit';
import { Emails } from 'views/account/emails';

import { OrgDetails } from 'views/client/work/close/index';
import { MonthEndCloseManager } from 'views/client/work/close/monthEndCloseManager';
import { CreateNewClose } from 'views/client/work/close/createNewClose';
import { TransactionCleanup } from 'views/client/work/cleanup';
import { ChartOfAccountsMonitor } from 'views/client/monitors/accountMonitors';
import { ReportCreator } from 'views/client/work/reports';


const Routes = [
  {
    path: '/dashboard',
    view: Dashboard,
    layout: 'app',
    permission: 'user',
    title: 'Dashboard'
  },
  {
    path: '/healthScore',
    view: HealthScore,
    layout: 'app',
    permission: 'user',
    title: 'Health Score'
  },
  {
    path: '/welcome',
    view: OnboardingView,
    layout: 'onboarding',
    permission: 'user',
    title: 'Welcome'
  },
  {
    path: '/help',
    view: Help,
    layout: 'app',
    permission: 'user',
    title: 'Get Help'
  },
  {
    path: '/app/error',
    view: Error,
    layout: 'app',
    permission: 'user',
    title: 'Error'
  },
  {
    path: '/client/connections',
    view: AppConnection,
    layout: 'app',
    permission: 'user',
    title: 'Connections'
  },
  {
    path: '/client/logs/cleanup',
    view: Monitors,
    layout: 'app',
    permission: 'user',
    accountType: 'full_monitoring',
    title: 'Clean-Up'
  },
  {
    path: '/client/monitors/accounts',
    view: ChartOfAccountsMonitor,
    layout: 'app',
    permission: 'user',
    accountType: 'full_monitoring',
    title: 'GL Account Monitors'
  },
  {
    path: '/client/monitors/rules',
    view: Rules,
    layout: 'app',
    permission: 'user',
    accountType: 'full_monitoring',
    title: 'Monitors'
  },
  {
    path: '/client/monitors/ruleDetails/:id',
    view: RuleDetails,
    layout: 'app',
    permission: 'user',
    accountType: 'full_monitoring',
    title: 'Rule Details'
  },
  {
    path: '/client/monitors/ruleDetails',
    view: RuleDetails,
    layout: 'app',
    permission: 'user',
    accountType: 'full_monitoring',
    title: 'Create Monitor'
  },
  {
    path: '/client/monitors/details/:id',
    view: MonitorsDetails,
    layout: 'app',
    permission: 'user',
    accountType: 'full_monitoring',
    title: 'Record Details'
  },
  {
    path: '/client/logs',
    view: Activity,
    layout: 'app',
    permission: 'user',
    accountType: 'full_monitoring',
    title: 'Activity Logs'
  },
  {
    path: '/client/tools/restore',
    view: Restore,
    layout: 'app',
    permission: 'user',
    accountType: 'full_monitoring',
    title: 'Restore'
  },
  {
    path: '/app/work/Cleanup',
    view: Monitors,
    layout: 'app',
    permission: 'user',
    title: 'Clean-Up'
  },
  {
    path: '/client/tools/metrics',
    view: ReportDashboard,
    layout: 'app',
    permission: 'user',
    accountType: 'full_monitoring',
    title: 'Metrics Dashboard'
  },
  {
    path: '/client/tools/export',
    view: Export,
    layout: 'app',
    permission: 'user',
    title: 'Data Exports'
  },
  {
    path: '/client/tools/restore/history',
    view: RestoreHistory,
    layout: 'app',
    permission: 'user',
    title: 'Restore History'
  },
  {
    path: '/client/tools/restore/details/:id',
    view: RestoreDetails,
    layout: 'app',
    permission: 'user',
    title: 'Restore Details'
  },
  {
    path: '/client/logs/details/:id',
    view: Details,
    layout: 'app',
    permission: 'user',
    title: 'Record Details'
  },
  {
    path: '/client/ai/analysis',
    view: Analysis,
    layout: 'app',
    permission: 'user',
    title: 'AI Analysis'
  },
  {
    path: '/client/ai',
    view: Chat,
    layout: 'app',
    permission: 'user',
    title: 'AI Assistant'
  },
  {
    path: '/client/ai/agents',
    view: Agents,
    layout: 'app',
    permission: 'user',
    title: 'AI Assistant'
  },
  {
    path: '/app/account',
    view: Account,
    layout: 'app',
    permission: 'admin',
    title: 'Account Details'
  },
  // {
  //   path: '/app/account/users',
  //   view: AccountUsers,
  //   layout: 'app',
  //   permission: 'admin',
  //   title: 'Users'
  // },
  {
    path: '/app/account/apikeys',
    view: APIKeyList,
    layout: 'app',
    permission: 'developer', 
    title: 'API Keys'
  },
  {
    path: '/app/account/apikeys/create',
    view: APIKeyEditor,
    layout: 'app',
    permission: 'developer', 
    title: 'API Keys'
  },
  {
    path: '/app/account/apikeys/edit',
    view: APIKeyEditor,
    layout: 'app',
    permission: 'developer',
    title: 'API Keys'
  },
  {
    path: '/app/account/emails',
    view: Emails,
    layout: 'app',
    permission: 'admin',
    title: 'E-mail Info'
  },

  {
    path: '/client/work/close',
    view: OrgDetails,
    layout: 'app',
    permission: 'user',
    title: 'Close History'
  },
  {
    path: '/client/work/close/:closeId',
    view: MonthEndCloseManager,
    layout: 'app',
    permission: 'user',
    title: 'Close Checklist'
  },
  {
    path: '/client/work/close/create',
    view: CreateNewClose,
    layout: 'app',
    permission: 'user',
    title: 'Create New Close'
  },
  {
    path: '/client/work/cleanup',
    view: TransactionCleanup,
    layout: 'app',
    permission: 'user',
    title: 'Data Clean-Up'
  },
  {
    path: '/app/glMonitors',
    view: ChartOfAccountsMonitor,
    layout: 'app',
    permission: 'user',
    title: 'General Ledger Review'
  },
  {
    path: '/client/work/reports',
    view: ReportCreator,
    layout: 'app',
    permission: 'user',
    title: 'Reports'
  }
]

export default Routes;
